import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import PaymentMethod from "../PaymentMethod";
import Billing from "../Billing";
import ManagerSubscription from "../ManagerSubscription";
import {
  getTeamActivityLogs,
  getSubscriptionOverview,
} from "@/features/tokens/api/token.api";
import { useGetApiToken } from "@/features/tokens/api/token.queries";

export default function ManagerOverview() {
  const queryClient = useQueryClient();
  const { data: apiTokenData } = useGetApiToken(1, 50, true);
  // Prefetch data for ManagerUsage tab when ManagerOverview is mounted
  useEffect(() => {
    const prefetchUsageData = async () => {
      try {
        await Promise.all([
          queryClient.prefetchQuery({
            queryKey: ["api-token"],
            queryFn: () => apiTokenData,
            staleTime: 30 * 1000,
          }),
          queryClient.prefetchQuery({
            queryKey: ["subscription-overview"],
            queryFn: () => getSubscriptionOverview(),
            staleTime: 30 * 1000,
          }),
          queryClient.prefetchQuery({
            queryKey: ["team-activity-logs", 1, 50],
            queryFn: () => getTeamActivityLogs({ page: 1, limit: 50 }),
            staleTime: 30 * 1000,
          }),
        ]);
      } catch (error) {
        console.warn("Failed to prefetch usage data:", error);
      }
    };

    const timeoutId = setTimeout(prefetchUsageData, 100);

    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryClient]);

  return (
    <div className="flex h-full min-h-0 w-full flex-col gap-5 overflow-y-auto bg-transparent p-0">
      <div className="flex-shrink-0">
        <ManagerSubscription />
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto">
        <PaymentMethod />
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto">
        <Billing />
      </div>
    </div>
  );
}
